import React, { useEffect } from "react";
import "../App.css";

function DataDeletion() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <nav
        className="navbar"
        style={{
          backgroundImage: "url(/images/Hero.png)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="nav-container"
          onClick={() => (window.location.href = "/")}
        >
          <div className="logo">
            <img src="/images/logo.png" alt="Logo" />
          </div>

          <button className="nav-button">
            <a href="tel:+919602326570">Call Us +91-9602326570</a>
          </button>
        </div>
      </nav>

      <h3 className="tncHeading">User Data Deletion Instructions</h3>
      <div className="text-container">
        <p className="normal-pg">
          Zivoro, operated by Jewel Nexus Technologies Private Limited, respects
          your privacy and provides a way to request deletion of personal
          information processed through its platform.
        </p>

        <p className="sub-heading">How to request deletion</p>
        <p className="normal-pg">
          To request deletion of your personal data associated with Zivoro or a
          business account connected to our platform, email{" "}
          <a href="mailto:shivank@zivoro.ai?subject=Data%20Deletion%20Request">
            shivank@zivoro.ai
          </a>{" "}
          with the subject line <strong>Data Deletion Request</strong>.
        </p>
        <p className="normal-pg" style={{ paddingTop: "16px" }}>
          Please include enough information for us to identify the relevant
          account. Do not send passwords or access tokens.
        </p>

        <p className="sub-heading">What happens next</p>
        <p className="normal-pg">
          We will review your request, verify your identity where necessary, and
          inform you of the next steps. Eligible data will be deleted within the
          applicable timeframe, subject to legal, security, and legitimate
          record-retention requirements.
        </p>

        <p className="sub-heading">Contact</p>
        <p className="normal-pg" style={{ marginBottom: "50px" }}>
          Jewel Nexus Technologies Private Limited
          <br />
          Email:{" "}
          <a href="mailto:shivank@zivoro.ai">shivank@zivoro.ai</a>
          <br />
          Website:{" "}
          <a href="https://zivoro.ai/" target="_blank" rel="noopener noreferrer">
            https://zivoro.ai/
          </a>
        </p>
      </div>
    </div>
  );
}

export default DataDeletion;
